function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "iot_svg__a",
  x: 14.154,
  y: 21.922,
  width: 31.17,
  height: 31.17,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c"
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "iot_svg__c",
  x: 5.025,
  y: 12.842,
  width: 41.058,
  height: 41.058,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  result: "d"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c"
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "d"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "iot_svg__e",
  x: 13.395,
  y: 21.114,
  width: 41.058,
  height: 41.058,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  result: "f"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c"
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "f"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "iot_svg__g",
  x: 8.439,
  y: 16.135,
  width: 37.424,
  height: 37.424,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  result: "h"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c"
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "h"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "iot_svg__i",
  x: 13.614,
  y: 21.454,
  width: 37.424,
  height: 37.424,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  result: "j"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c"
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "j"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".iot_svg__d,.iot_svg__g,.iot_svg__j{fill:none}.iot_svg__d,.iot_svg__e,.iot_svg__g{stroke:#ff6c6c;stroke-linecap:round}.iot_svg__d{stroke-linejoin:round}.iot_svg__d,.iot_svg__g{stroke-width:2px}.iot_svg__e{fill:#ff6c6c}.iot_svg__h{stroke:none}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#383d5a"
}, /*#__PURE__*/React.createElement("path", {
  className: "iot_svg__h",
  d: "M48.142 33.99H13.42c-5.276 0-9.567-4.289-9.567-9.562s4.291-9.562 9.567-9.562c1.244 0 2.45.234 3.584.693l1.068.434.28-1.118a14.033 14.033 0 014.89-7.566A13.823 13.823 0 0131.9 4.3c7.412 0 13.537 5.793 13.945 13.19l.059 1.058 1.053-.119a7.748 7.748 0 016.303 2.242 7.743 7.743 0 012.285 5.518 7.784 7.784 0 01-2.032 5.252 7.788 7.788 0 01-4.988 2.511l-.383.038z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.093 32.99l.334-.033a6.779 6.779 0 004.346-2.19 6.784 6.784 0 001.772-4.577c0-3.752-3.053-6.803-6.805-6.803-.236 0-.461.012-.67.035l-2.107.242-.116-2.119C44.468 10.68 38.783 5.301 31.9 5.301c-2.951 0-5.73.965-8.037 2.793a13.024 13.024 0 00-4.541 7.024l-.559 2.236-2.134-.867a8.48 8.48 0 00-3.21-.621c-4.722 0-8.566 3.841-8.566 8.562 0 4.72 3.844 8.563 8.567 8.563h34.673m.532 2H13.42c-5.832 0-10.567-4.73-10.567-10.563 0-5.83 4.735-10.562 10.567-10.562 1.398 0 2.744.273 3.96.767C19.005 8.121 24.89 3.301 31.9 3.301c7.982 0 14.51 6.252 14.943 14.135.291-.033.596-.049.897-.049a8.8 8.8 0 018.805 8.803 8.802 8.802 0 01-7.92 8.758v.043z",
  fill: "#1b1c26"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.049 23.273l8.31 14.49-8.31 14.49H21.428l-8.31-14.49 8.31-14.49z",
  fill: "#1b1c26"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "iot_svg__d",
  d: "M26.798 52.257h11.125"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "iot_svg__e",
  transform: "rotate(90 -5.36 45.19)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__h",
  width: 3.409,
  height: 3.409,
  rx: 1.705
}), /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__j",
  x: -0.5,
  y: -0.5,
  width: 4.409,
  height: 4.409,
  rx: 2.205
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "iot_svg__d",
  d: "M40.724 47.893l5.73-9.536"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "iot_svg__e",
  transform: "rotate(31 -41.637 100.81)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__h",
  width: 3.409,
  height: 3.409,
  rx: 1.705
}), /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__j",
  x: -0.5,
  y: -0.5,
  width: 4.409,
  height: 4.409,
  rx: 2.205
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "iot_svg__d",
  d: "M44.006 33.211l-5.562-9.635"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  className: "iot_svg__e",
  transform: "rotate(-30 60.51 -55.812)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__h",
  width: 3.409,
  height: 3.409,
  rx: 1.705
}), /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__j",
  x: -0.5,
  y: -0.5,
  width: 4.409,
  height: 4.409,
  rx: 2.205
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "iot_svg__d",
  d: "M33.011 23.278H21.887"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  className: "iot_svg__e",
  transform: "rotate(90 .908 22.48)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__h",
  width: 3.409,
  height: 3.409,
  rx: 1.705
}), /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__j",
  x: -0.5,
  y: -0.5,
  width: 4.409,
  height: 4.409,
  rx: 2.205
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "iot_svg__d",
  d: "M19.084 27.642l-5.73 9.535"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  className: "iot_svg__e",
  transform: "rotate(31 -56.79 40.341)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__h",
  width: 3.409,
  height: 3.409,
  rx: 1.705
}), /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__j",
  x: -0.5,
  y: -0.5,
  width: 4.409,
  height: 4.409,
  rx: 2.205
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "iot_svg__d",
  d: "M15.803 42.32l5.562 9.634"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  className: "iot_svg__e",
  transform: "rotate(-30 105.681 -9.956)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__h",
  width: 3.409,
  height: 3.409,
  rx: 1.705
}), /*#__PURE__*/React.createElement("rect", {
  className: "iot_svg__j",
  x: -0.5,
  y: -0.5,
  width: 4.409,
  height: 4.409,
  rx: 2.205
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#iot_svg__a)",
  transform: "translate(-.002 -.003)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.085,
  cy: 2.085,
  r: 2.085,
  transform: "translate(27.65 35.42)",
  fill: "#ff6c6c"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#iot_svg__c)",
  transform: "translate(-.002 -.003)"
}, /*#__PURE__*/React.createElement("path", {
  className: "iot_svg__g",
  d: "M22.256 38.424a7.408 7.408 0 012.165-6.24 7.633 7.633 0 016.139-2.144"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#iot_svg__e)",
  transform: "translate(-.002 -.003)"
}, /*#__PURE__*/React.createElement("path", {
  className: "iot_svg__g",
  d: "M37.224 36.586a7.408 7.408 0 01-2.165 6.24 7.633 7.633 0 01-6.139 2.144"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#iot_svg__g)",
  transform: "translate(-.002 -.003)"
}, /*#__PURE__*/React.createElement("path", {
  className: "iot_svg__g",
  d: "M24.897 37.99a4.752 4.752 0 011.401-3.925 4.96 4.96 0 014.072-1.385"
}));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#iot_svg__i)",
  transform: "translate(-.002 -.003)"
}, /*#__PURE__*/React.createElement("path", {
  className: "iot_svg__g",
  d: "M34.583 37.02a4.752 4.752 0 01-1.401 3.925 4.96 4.96 0 01-4.072 1.385"
}));

var SvgIot = function SvgIot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62.172
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

export default "data:image/svg+xml;base64,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";
export { SvgIot as ReactComponent };